export enum TokenEnum {
	TOKEN = 'token',
	INSCRIPTION_TOKEN = 'inscription_token',
	ID_TOKEN_HINT = 'id_token_hint'
}